import axios from 'axios';
import { takeEvery, call, put } from 'redux-saga/effects';

import {
    FETCH_EXERCISE_DATA,
    FETCH_EXERCISE_DATA_FETCHING,
    FETCH_EXERCISE_DATA_FINISHED
} from '../actions/ActionTypes';

export function* fetchExerciseData(action) {
    const { locale, categoryKey, exerciseKey } = action.payload;

    try {
        yield put({
            type: FETCH_EXERCISE_DATA_FETCHING
        });

        const url = `/web-data/exercises/${locale}/${categoryKey}/${exerciseKey}.json`;
        const response = yield call(axios.get, url, { baseURL: '/' });

        const exerciseData = {
            ...response.data,
            categoryKey: response.data.exerciseCategory,
            exerciseKey: response.data.exerciseName
        };

        delete exerciseData.exerciseCategory;
        delete exerciseData.exerciseName;

        yield put({
            type: FETCH_EXERCISE_DATA_FINISHED,
            exerciseData,
            receivedAt: Date.now()
        });
    } catch (e) {
        if (locale !== 'en-US') {
            yield call(fetchExerciseData, {
                payload: {
                    locale: 'en-US',
                    categoryKey,
                    exerciseKey
                }
            });
        }
    }
}

export const exerciseSagas = [takeEvery(FETCH_EXERCISE_DATA, fetchExerciseData)];
